import { Haptics, ImpactStyle } from '@capacitor/haptics';

const lightImpact = async function() {
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    // Browser doesn't support the vibrate API (e.g. Firefox on desktop).
  }
}

export { lightImpact }
